import { Button, Form, Header } from '../../components';
import ormActions from '../../orm/actions';
import { eventsSelector } from '../../orm/selectors';
import { bickActions } from '../../common';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pick } from 'lodash';

class Event extends Component {
  state = this.props.events[0] || {
    singleton: 'singleton',
    title: '',
    location: '',
    duration: '',
    mode: 'default',
  };

  onInputChange = (event, { name, value }) => {
    this.setState({ [name]: value });
  };

  onFormSubmit = () => {
    const { actions } = this.props;
    const { resetAll } = actions.orm.event;
    resetAll([
      pick(this.state, 'singleton', 'title', 'location', 'duration', 'mode'),
    ]);
  };

  render() {
    const { title, location, duration, mode } = this.state;
    return (
      <section>
        <Header as="h1">Event</Header>
        <Header as="h2">Information</Header>
        <Form onSubmit={this.onFormSubmit}>
          <Form.Group widths="equal">
            <Form.Input
              name="title"
              label="Title"
              value={title || ''}
              onChange={this.onInputChange}
              fluid
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              name="location"
              label="Location"
              value={location || ''}
              onChange={this.onInputChange}
              fluid
            />
            <Form.Input
              name="duration"
              label="Duration"
              value={duration || ''}
              onChange={this.onInputChange}
              fluid
            />
            {/*
            <Form.Field
              control={DateInput}
              name="dateBegin"
              label="Date (begin)"
              width={3}
            />
            <Form.Field
              control={DateInput}
              name="dateEnd"
              label="Date (end)"
              width={3}
            />
            */}
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              name="mode"
              label="Mode"
              value={mode || 'default'}
              options={[
                { key: 'default', value: 'default', text: 'Default' },
                { key: 'round', value: 'round', text: 'Round' },
              ]}
              onChange={this.onInputChange}
              fluid
            />
          </Form.Group>
          <Button content="Save" />
        </Form>
      </section>
    );
  }
}

const mapStateToProps = ({ orm }) => ({
  events: eventsSelector(orm),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    orm: bickActions(ormActions, ['event'], dispatch),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Event);



// WEBPACK FOOTER //
// ./src/pages/Setup/Event.js